import styled from "styled-components";
import { blogs, templates } from "../utils/constants";
import svgForBlog from "../utils/get-svg-for-blog";
import LayoutSplit from "../components/layout-split";
import Heading from "../components/heading";
import ListItem from "../components/list-item";
import Text from "../components/text";
import List from "../components/list";
import { useRecoilValue } from "recoil";
import userState from "../utils/user-state";
import { useHistory } from "react-router-dom";

const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
`;

const GridItem = styled.div`
  border-radius: 12px;
  border: 1px solid #eeeeee;
  padding: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  cursor: pointer;
  transition: 0.1s;

  img {
    height: 60px;
    width: 60px;
    margin-bottom: 1rem;
  }

  &:hover {
    border-color: #c8c8c8;
  }
`;

export default function OverviewScreen() {
  const user = useRecoilValue(userState);
  const history = useHistory();

  return (
    <>
      {user &&
        (user.permissions === "*" || user.permissions.includes("blogs")) && (
          <LayoutSplit>
            <div>
              <Heading>Blogs</Heading>
              <Text>
                Erstelle und bearbeite Artikel für die verschiedenen Blogs. Für
                den Blog <b>Küche</b> steht der Rezepte-Editor zur Verfügung,
                für die anderen ein angepasster Pagebuilder
              </Text>
            </div>
            <div>
              <Grid>
                {blogs.map((blog) => {
                  return (
                    <GridItem
                      key={blog.handle}
                      onClick={() => history.push("/blogs/" + blog.handle)}
                    >
                      <img src={svgForBlog(blog.handle)} alt={blog.title} />
                      {blog.title}
                    </GridItem>
                  );
                })}
              </Grid>
            </div>
          </LayoutSplit>
        )}

      {user &&
        (user.permissions === "*" || user.permissions.includes("pages")) && (
          <LayoutSplit>
            <div>
              <Heading>Seiten</Heading>
              <Text>
                Erstelle und bearbeite Seiten mit verschiedenen Vorlagen. Die
                Produkte sind jeweils oben eingebunden, können optional auch
                nach unten verschoben werden.
              </Text>
            </div>
            <div>
              <List>
                {templates.map((t) => (
                  <ListItem
                    key={t.handle}
                    onClick={() => history.push(`/pages/${t.handle}`)}
                  >
                    {t.title}
                  </ListItem>
                ))}
              </List>
            </div>
          </LayoutSplit>
        )}
      {user &&
        (user.permissions === "*" ||
          user.permissions.includes("components")) && (
          <LayoutSplit>
            <div>
              <Heading>Seiten-Komponenten</Heading>
              <Text>
                Die Vorlagen bestehen auch aus Komponenten wie Testimonials, die
                nicht im Pagebuilder bearbeitet werden können
              </Text>
            </div>
            <div></div>
          </LayoutSplit>
        )}
      {user && user.permissions === "" && (
        <LayoutSplit>
          <div>
            <Heading>Du hast keine Rechte 🥲</Heading>
          </div>
        </LayoutSplit>
      )}
    </>
  );
}
